// TODO: Fix eslint error.
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */

module.exports = function (request, currentRoute, data = {}) {
  return { status: currentRoute };
};
